import Responsive from "components/Responsive";
import { IntersectionObserverOptions } from "hooks/useIntersectionObserver";
import useOnScreen from "hooks/useOnScreen";
import React, { useRef } from "react";
import ParkingMeterAnimation from "./Animation";
import { animationMediaQueryConfig } from "./helper";
import ParkingMeterInfo from "./Info";
import { StyledFullPageContainer } from "./styles";

const intersectionOptions: IntersectionObserverOptions = {
  unobserveOnIntersection: true,
};

const ParkingMeter: React.FC = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const isOnScreen = useOnScreen(containerRef, intersectionOptions);

  return (
    <StyledFullPageContainer ref={containerRef}>
      <ParkingMeterInfo isOnScreen={isOnScreen} />
      <Responsive {...animationMediaQueryConfig}>
        <ParkingMeterAnimation />
      </Responsive>
    </StyledFullPageContainer>
  );
};

export default ParkingMeter;
